/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TaskStatusType } from './TaskStatusType.js';
import {
    TaskStatusTypeFromJSON,
    TaskStatusTypeFromJSONTyped,
    TaskStatusTypeToJSON,
} from './TaskStatusType.js';

/**
 * 
 * @export
 * @interface UpdateTaskRequest
 */
export interface UpdateTaskRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskRequest
     */
    title?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskRequest
     */
    assignedTo?: number;
    /**
     * 
     * @type {Date}
     * @memberof UpdateTaskRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskRequest
     */
    content?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateTaskRequest
     */
    priority?: number;
    /**
     * 
     * @type {TaskStatusType}
     * @memberof UpdateTaskRequest
     */
    status?: TaskStatusType;
}

/**
 * Check if a given object implements the UpdateTaskRequest interface.
 */
export function instanceOfUpdateTaskRequest(value: object): boolean {
    return true;
}

export function UpdateTaskRequestFromJSON(json: any): UpdateTaskRequest {
    return UpdateTaskRequestFromJSONTyped(json, false);
}

export function UpdateTaskRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'content': json['content'] == null ? undefined : json['content'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'status': json['status'] == null ? undefined : TaskStatusTypeFromJSON(json['status']),
    };
}

export function UpdateTaskRequestToJSON(value?: UpdateTaskRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'assignedTo': value['assignedTo'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString()),
        'content': value['content'],
        'priority': value['priority'],
        'status': TaskStatusTypeToJSON(value['status']),
    };
}

